import { render } from "./body-mask-height.vue?vue&type=template&id=e45264c0"
import script from "./body-mask-height.vue?vue&type=script&lang=js"
export * from "./body-mask-height.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__